'use strict';

const { getWidth } = require('../../deal/frontend/get_dimensions');

const MemberOnly = {
  init(payload, done) {
    // We want to set the width of the tooltip with the same width of the container.
    // And the gig tooltip code move the tooltip to the end of body

    const $memberOnly = document.querySelector('.member-only');
    const $memberOnlyTooltip = document.querySelector('#member_only_tooltip');

    if ($memberOnly && $memberOnlyTooltip) {
      $memberOnlyTooltip.style.width = `${getWidth($memberOnly)}px`;
    }

    return done();
  },
};

module.exports = MemberOnly;
